/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const getters = {
  scrollbarTag: (state) => {
    return state.is_touch_device ? "div" : "VuePerfectScrollbar"
  },

  zenoRadioURL: () => {
    return process.env.VUE_APP_ZENO_RADIO_URL
  },
}

export default getters
